<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <v-tabs>
          <v-tab :to="{name: 'teacherReport', params: {period: period}}">Преподаватели</v-tab>
          <v-tab :to="{name: 'departmentReport', params: {period: period}}">Кафедры</v-tab>
        </v-tabs>
        <router-view></router-view>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({}),
  computed: {
    period() {
        return this.$route.params.period
    }
  },
  mounted() {
  },
  methods: {}
}
</script>
